import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#aa44aa",
    },
    secondary: {
      main: "#035dda",
    },
  },
});
